import {ReactNode} from "react";
import {css} from "@panda/css";

interface IProps {
    children: ReactNode;
}

export const DetailSectionWrapper = (props: IProps) => {
    const {children} = props;

    return <div className={wrapper}>{children}</div>;
};

const wrapper = css({
    borderRadius: 2,
    backgroundColor: "var(--colors-white)",
    padding: 3
});
import {ReactNode} from "react";
import {css} from "@panda/css";

interface IProps {
    children: ReactNode;
}

export const DetailSectionWrapper = (props: IProps) => {
    const {children} = props;

    return <div className={wrapper}>{children}</div>;
};

const wrapper = css({
    borderRadius: 2,
    backgroundColor: "var(--colors-white)",
    padding: 3
});
